import { Map as MDBMap } from './mdb';
import { Map as TXTMap } from './txt';

export class Skola24Map {
  static MDB = MDBMap;
  static TXT = TXTMap;
}

export type { Types as Skola24MDBTypes } from './mdb';
export type { Types as Skola24TXTTypes } from './txt';
